<aside class="sidebar" [class.sidebar--collapsed]="collapsed">
  <!-- ===== CABECERA: Logo + Botón Toggle ===== -->
  <div class="flex flex-column align-items-center gap-3">
    @if (!collapsed) {
      <img
        class="sidebar__logo-full"
        src="assets/images/logoMetis-exp.png"
        alt="Metis 360"
      />
    } @else {
      <img
        class="sidebar__logo-icon"
        src="assets/images/logoMetis-cont.png"
        alt="M"
      />
    }

    <p-button
      [icon]="collapsed ? 'pi pi-chevron-right' : 'pi pi-chevron-left'"
      [rounded]="true"
      variant="text"
      size="small"
      (click)="toggleSidebar()"
      [pTooltip]="collapsed ? 'Expandir menú' : 'Colapsar menú'"
      tooltipPosition="right"
    />
  </div>

  <!-- ===== NAVEGACIÓN PRINCIPAL ===== -->
  <nav class="sidebar__nav flex-1 py-2 w-full">
    <ul class="list-none p-0 m-0 flex flex-column gap-1">
      @for (item of visibleMenuItems(); track item.route) {
        <li class="">
          <div class="pl-3">
            <a
              [routerLink]="item.route"
              class="sidebar__nav-link flex gap-3 cursor-pointer no-underline transition-all transition-duration-200 w-full"
              [class.sidebar__nav-link--active]="isItemActive(item)"
              [class.justify-content-center]="collapsed"
              [pTooltip]="item.label"
              [tooltipDisabled]="!collapsed"
              tooltipPosition="right"
              pRipple
            >
              <i [class]="'sidebar__nav-icon text-xl flex-shrink-0 ' + item.icon"></i>
              @if (!collapsed) {
                <span class="sidebar__nav-label white-space-nowrap overflow-hidden text-overflow-ellipsis">
                  {{ item.label }}
                </span>
              }
            </a>
          </div>
        </li>
      }
    </ul>
  </nav>

  <!-- ===== PIE: Configuración + Cerrar Sesión ===== -->
  <div class="sidebar__footer mt-auto">

    <ul class="list-none p-0 m-0 flex flex-column justify-content-center align-items-center gap-1">
      <li class="pl-2 w-full">
        <a
          routerLink="/app/configuration"
          routerLinkActive="sidebar__nav-link--active"
          class="sidebar__nav-link text-color flex align-items-center gap-3 border-round-xl cursor-pointer no-underline transition-all transition-duration-200"
          [pTooltip]="'Configuración'"
          [tooltipDisabled]="!collapsed"
          tooltipPosition="right"
          pRipple
        >
          <i class="pi pi-cog sidebar__nav-icon text-xl flex-shrink-0"></i>
          @if (!collapsed) {
            <span class="sidebar__nav-label font-medium white-space-nowrap">Configuración</span>
          }
        </a>
      </li>

      <li>
        <p-button
          icon="pi pi-sign-out"
          [label]="collapsed ? '' : 'Cerrar sesión'"
          [text]="true"
          severity="danger"
          [pTooltip]="'Cerrar sesión'"
          [tooltipDisabled]="!collapsed"
          tooltipPosition="right"
          (onClick)="logout()"
        />
      </li>
    </ul>
  </div>

</aside>
